<template>
    <tabs-section
        class="c-field_text"
        :has-history="visit.status === 'completed'"
        :btn-label="nextLabel"

        :title="title"
        :empty="value === ''"
        :saved="value !== null"
        @history="openHistory"
        @next="save">

        <visit-history-previous
            v-if="lastVisit !== null && lastValueExist"
            @copy="newValue += lastVisit[name]">
            {{ lastVisit[name] }}
        </visit-history-previous>

        <form-input
            type="textarea"
            :label="label"
            v-model="newValue"
            speech-to-text>
        </form-input>

        <visit-history-modal ref="textHistoryModal" :title="title" @fetched="updateHistory">
            <visit-history-item
                class="c-field_text__history"
                v-for="(item, index) in fieldHistory"
                :key="index"
                :date="item.datetime"
                :author="item.physiotherapist">
                {{ item.value || '&mdash;' }}
            </visit-history-item>
        </visit-history-modal>
    </tabs-section>
</template>


<script>

import {mapGetters} from 'vuex'
import {FormInput} from 'Components/Form'
import {TabsSection} from 'Components/Tabs'

import VisitHistoryModal from 'Components/Visit/VisitHistoryModal'
import VisitHistoryItem from 'Components/Visit/VisitHistoryItem'
import VisitHistoryPrevious from 'Components/Visit/VisitHistoryPrevious'

import noReact from 'Utils/NoReact'

export default {

    name: 'VisitFieldText',

    props: {
        value: String,
        name: String,
        label: String,
        title: String
    },

    data() {
        return {
            fieldHistory: [],
            isLoading: false,
            newValue: noReact(this.value) || ''
        }
    },

    computed: {
        ...mapGetters(['visit', 'lastVisit']),
        lastValueExist() {
            return typeof this.lastVisit[this.name] !== 'undefined'
                && this.lastVisit[this.name] !== null
                && this.lastVisit[this.name].trim() !== ''
        },
        nextLabel() {
            if (!this.isEdited || (this.value === null && this.newValue.length === 0))
                return 'Dalej'
            return 'Zapisz'
        },
        isEdited() {
            return this.newValue !== this.value
        }
    },

    methods: {
        save(nextSection) {
            if (!this.isEdited) {
                nextSection()
                return
            }
            this.$store.dispatch('VISIT_FIELD_UPDATE', {
                id: this.$route.params.id1,
                value: this.newValue,
                field: this.name
            }).then((response) => {
                this.$alert.success('Przebieg wizyty', response.data.message, 2000)
                nextSection()
            }).catch((error) => {
                nextSection(false)
                this.$alert.error('Przebieg wizyty', error.response.data.message)
            })
        },
        openHistory() {
            this.$refs.textHistoryModal.$emit('open', this.name)
        },
        updateHistory(history) {
            this.fieldHistory = history
        }
    },

    components: {
        VisitHistoryPrevious,
        VisitHistoryItem,
        VisitHistoryModal,
        FormInput,
        TabsSection
    }
}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-field_text {

}

</style>

